function initLeadModal({leadId, whatsappNumber, phone, location}) {


    $('#dashboardDate-' + leadId).datepicker({
        format: "dd-MM-yyyy",
        todayHighlight: true,
        autoclose: true,
        endDate: new Date(new Date().setDate(new Date().getDate() + 7)),
        startDate: new Date()
    });

    $(document).on('change', '.country-select', function() {
        var countryId = $(this).val();
        var dependent = $(this).data('dependent');
        console.log('country Id:', countryId);

        if (countryId) {
            $.ajax({
                url: '/get-governments/' + countryId,
                method: 'GET',
                success: function(data) {
                    var governmentSelect = $('#' + dependent);
                    governmentSelect.empty().append('<option value="">Select Government</option>');
                    $.each(data.governments, function(index, government) {
                        governmentSelect.append('<option value="' + government.id + '">' + government.name + '</option>');
                    });
                    governmentSelect.trigger('change');
                }
            });
        } else {
            $('#' + dependent).empty().append('<option value="">Select Government</option>');
        }
    });

    // Initialize Select2
    $('.select2-element').select2({
        theme: 'bootstrap-5',
        placeholder: "Select an option",
        allowClear: true
    });

    $("#addProduct").on('click', function (e) {
        e.preventDefault();
        var lastItem = $('#parent div.pro2').last();
        var productID = lastItem.find('select[name="product_id[]"]').val();
        var productIDF =  $('#parent div.pro2').find('select[id="lead-product-0"]').val();
        var lastname_id = lastItem.attr('id'),
            split_id    = lastname_id.split('_'),
            index       = Number(split_id[1]) + 1,
            newel       = $('.pro2:last').clone(true);
        $(newel).attr("index", index);
        $(newel).attr("id","item_"+index);
        $(newel).find('button').attr("id","remove_"+index);
        $(newel).find('button').attr("data-action",0);
        $(newel).find('.product-select').attr("id","lead-product-"+index);
        $(newel).find('select[name="product_id[]"] option[value="'+productID+'"]').remove();
        $(newel).find('select[name="product_id[]"] option[value="'+productIDF+'"]').remove();
        $(newel).find('.leadamount').attr("id","leadamount-"+index);
        $(newel).find('.leadprice').attr("id","leadprice-"+index);

        $(newel).find('select[name="product_id[]"]').val('');
        $(newel).find('input[name="quantity[]"]').val('');
        $(newel).find('input[name="price[]"]').val('');
        $(newel).insertAfter(".pro2:last");
    });

    $(".pro2 button").click(function (e) {
        e.preventDefault();
        if($(this).attr('id') !== 'remove_0') {
            var  leadProductId = $(this).attr('data-action');
            if(leadProductId !== 0) {
                Swal.fire({
                    title: "Are you sure ?",
                    text: "You will Delete Product !",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it !",
                    cancelButtonText: "No, cancel !",
                    closeOnConfirm: false,
                    closeOnCancel: false
                }).then((confirmed) => {
                    if (confirmed.value == true) {
                        $(this).closest('.pro2').remove();
                        axios.post(`/api/order/product_delete/${leadProductId}/delete`, {}).then(function (response){
                            Swal.fire("Suceess", "Product Delete Suceessfully", "success");
                            if(typeof initializeDatatable === 'function') initializeDatatable();
                        })
                    } else if(confirmed.dissmiss == "cancel") {
                        Swal.fire("Cancelled", "Status UnchangededitOrder !", "error");
                    }
                });
            }
        }
    });

    $('#leadcountry-' + leadId).change(function() {
        var value = $(this).val();
        var dependent = $(this).data('dependent');
        axios.post(`/api/countries/get-governments`,{
            value: value,
            dependent:dependent,
        })
        .then(function (response) {
            $('#'+dependent).html(response.data);
        }, error => {});
    });

    $('.dynamic').change(function() {
        if($(this).val() != '') {
            var value = $(this).val();
            var dependent = $(this).data('dependent');
            axios.post(`/api/governments/get-areas`,{
                value: value,
                dependent:dependent,
            })
            .then(function (response) {
                $('#'+dependent).html(response.data);
            }, error => {});
        }
    });

    $('#leadarea-' + leadId).on('change', function() {
        if($(this).val() != '') {
            axios.post(`/api/regions/getRegions`,{
                value: $('select.area-select').val(),
            })
            .then(function (response) {
                $('select.region-select').html(response.data);
            }, error => {});
        }
    });

    // Availabilty logic
    var div = $('#availabilty-' + leadId).val();
    function updateAvailabilityUI(div) {
        if(div == 'wrong-number') {
            $('.wrong-number').show();
            $('.client-type').hide();
            $('.call-status').show();
            $('.confirmed, .follow-up-schedule, .unconfirmed-call, .unsuccessful-call, .canceled, .other').hide();
        }else if(div == 'Available To Talk') {
            $('.wrong-number').hide();
            $('.confirmed, .follow-up-schedule, .unconfirmed-call, .unsuccessful-call, .canceled, .other').show();
            $('.client-type').show();
            $('.call-status').show();
        }else if(div == 'Not Available To Talk') {
            $('.client-type').hide();
            $('.call-status').show();
            $('.follow-up-schedule, .other').show();
            $('.confirmed, .unconfirmed-call, .unsuccessful-call, .canceled, .wrong-number').hide();
        }else if(div == 'canceled') {
            $('.client-type').hide();
            $('.call-status').show();
            $('.follow-up-schedule, .other').show();
            $('.confirmed, .unconfirmed-call, .unsuccessful-call, .canceled, .wrong-number').hide();
        }
    }
    updateAvailabilityUI(div);
    $('#availabilty-' + leadId).on('change', function() {
        updateAvailabilityUI($(this).val());
    });

    $('#leadcallstatus-' + leadId).on('change', function() {
        const $leadModal = $('.update-modal-lead');
        const $rescheduleTime = $('#reschedule-time-' + leadId);
        const $datetimepicker = $('#datetimepicker1-' + leadId);
        const $createOrder = $('#create-order-' + leadId);
        const $cancelledReasons = $('#cancelled-reasons-' + leadId);
        const $leadCancelledReason = $('#leadCancelledReason-' + leadId);
        $leadModal.removeClass('disabled').css("pointer-events", "auto");
        $createOrder.hide();
        $rescheduleTime.hide();
        $cancelledReasons.hide();
        $leadCancelledReason.removeAttr('required').val('');
        const status = $(this).val();
        switch(status) {
            case 'follow-up-schedule':
                $rescheduleTime.show();
                if (!$datetimepicker.hasClass('initialized')) {
                    $datetimepicker.datetimepicker({
                        inline: true,
                        sideBySide: true,
                        stepping: 15,
                        format: 'YYYY-MM-DD H:mm:ss',
                    }).addClass('initialized');
                }
                break;
            case 'confirmed':
                $createOrder.show();
                break;
            case 'canceled':
                $createOrder.hide();
                $cancelledReasons.show();
                $leadCancelledReason.attr('required', true);
                break;
            default:
                $createOrder.hide();
                $rescheduleTime.hide();
                $cancelledReasons.hide();
                $leadCancelledReason.removeAttr('required').val('');
                break;
        }
    });

    // Questions tab logic
    $('#questions.que-lead-' + leadId + ' select').on('change', function() {
        let element = $(this).attr('name');
        let val = $(this).val();
        if (val == 'yes' || val == 'others') {
            $('div.div_'+element+'_note').removeClass('d-none');
            $('div.div_'+element+'_note textarea').removeAttr('disabled');
        } else {
            $('div.div_'+element+'_note').addClass('d-none');
            $('div.div_'+element+'_note textarea').attr('disabled', 'disabled');
        }
    });

    // Google Maps logic
    $("#pac-input").focusin(function() {});
    $('#latitude-' + leadId).val('');
    $('#longitude-' + leadId).val('');

    window.initAutocomplete = function() {
        const locationLatLng = {
            lat: parseFloat(location[0] ?? '26.820553'),
            lng: parseFloat(location[1] ?? '30.802498')
        };
        var map = new google.maps.Map(document.getElementById('map'), {
            center: locationLatLng,
            zoom: 10,
        });
        let infowindow = new google.maps.InfoWindow();
        let geocoder = new google.maps.Geocoder();
        var icon = {
            url: "https://maps.gstatic.com/mapfiles/ms2/micons/green-dot.png",
            scaledSize: new google.maps.Size(50, 50),
            origin: new google.maps.Point(0,0),
            anchor: new google.maps.Point(25, 48)
        };
        const marker = new google.maps.Marker({
            icon: icon,
            map, position: locationLatLng
        });
        marker.addListener("click", () => {
            infowindow.open(map, marker);
        });
        geocodeLatLng(geocoder, map, infowindow, locationLatLng);
        google.maps.event.addListener(map, 'click', function(event) {
            let SelectedLatLng = event.latLng;
            geocoder.geocode({
                'latLng': event.latLng
            }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (results[0]) {
                        deleteMarkers();
                        addMarkerRunTime(event.latLng);
                        SelectedLocation = results[0].formatted_address;
                        splitLatLng(String(event.latLng));
                        $("#pac-input").val(results[0].formatted_address);
                    }
                }
            });
        });
        function geocodeLatLng(geocoder, map, infowindow, markerCurrent) {
            var latlng = {lat: markerCurrent.lat, lng: markerCurrent.lng};
            geocoder.geocode({'location': latlng}, function(results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        map.setZoom(8);
                        var marker = new google.maps.Marker({
                            position: latlng,
                            map: map
                        });
                        markers.push(marker);
                        infowindow.setContent(results[0].formatted_address);
                        let SelectedLocation = results[0].formatted_address;
                        $("#pac-input").val(results[0].formatted_address);
                        infowindow.open(map, marker);
                    } else {
                        window.alert('No results found');
                    }
                } else {
                    window.alert('Geocoder failed due to: ' + status);
                }
            });
            let SelectedLatLng = (markerCurrent.lat, markerCurrent.lng);
        }
        function addMarkerRunTime(location) {
            var marker = new google.maps.Marker({
                position: location,
                map: map
            });
            markers.push(marker);
        }
        function setMapOnAll(map) {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(map);
            }
        }
        function clearMarkers() {
            setMapOnAll(null);
        }
        function deleteMarkers() {
            clearMarkers();
            markers = [];
        }
        var input = document.getElementById("pac-input");
        var searchBox = new google.maps.places.SearchBox(input);
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
        map.addListener('bounds_changed', function() {
            searchBox.setBounds(map.getBounds());
        });
        var markers = [];
        searchBox.addListener('places_changed', function() {
            var places = searchBox.getPlaces();
            if (places.length == 0) {
                return;
            }
            markers.forEach(function(marker) {
                marker.setMap(null);
            });
            markers = [];
            var bounds = new google.maps.LatLngBounds();
            places.forEach(function(place) {
                if (!place.geometry) {
                    console.log("Returned place contains no geometry");
                    return;
                }
                var icon = {
                    url: place.icon,
                    size: new google.maps.Size(100, 100),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 34),
                    scaledSize: new google.maps.Size(25, 25)
                };
                markers.push(new google.maps.Marker({
                    map: map,
                    icon: icon,
                    title: place.name,
                    position: place.geometry.location
                }));
                $('#latitude-' + leadId).val(place.geometry.location.lat());
                $('#longitude-' + leadId).val(place.geometry.location.lng());
                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });
            map.fitBounds(bounds);
        });
    };
    window.handleLocationError = function(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(browserHasGeolocation ?
            'Error: The Geolocation service failed.' :
            'Error: Your browser doesn\'t support geolocation.');
        infoWindow.open(map);
    };
    window.splitLatLng = function(latLng) {
        var newString = latLng.substring(0, latLng.length-1);
        var newString2 = newString.substring(1);
        var trainindIdArray = newString2.split(',');
        var lat = trainindIdArray[0];
        var Lng  = trainindIdArray[1];
        $('#latitude-' + leadId).val(lat);
        $('#longitude-' + leadId).val(Lng);
    };
    $('#confirmedLocation').on('click', function() {
        if ($('#latitude-' + leadId).val().length > 0 && $('#clearLocation').hasClass('d-none')) {
            $('#clearLocation').removeClass('d-none');
        }
    });
    $('#clearLocation').addClass( $('#longitude-' + leadId).val() ? '' : 'd-none' );
    $('#clearLocation').on('click', function() {
        $('#latitude-' + leadId).val(location[0] ?? null);
        $('#longitude-' + leadId).val(location[1] ?? null);
        !$('#clearLocation').hasClass('d-none') ?  $('#clearLocation').addClass('d-none') : '';
    });
    // QR Code
    var qrValue = `BEGIN:VCARD\nVERSION:2.1\nN:;lead\nFN:lead\nTEL:${whatsappNumber || phone}\nEND:VCARD`;
    new QRCode(document.getElementById("phone-qrcode"), {
        text: qrValue,
        width: 200,
        height: 200,
        colorDark : "#000000",
        colorLight : "#ffffff",
        correctLevel : QRCode.CorrectLevel.M
    });
    $("#send-msg-whats").on('click', function() {
        var msgText = $('#msg-whats-app').val();
        var sendPhone = whatsappNumber;
        if(!sendPhone || sendPhone === '') {
            sendPhone = phone;
        }
        if (sendPhone.toString().substring(0, 2) == '01') {
            sendPhone = '+2' + sendPhone;
        } else if (sendPhone.toString().substring(0, 1) == '1') {
            sendPhone = '+20' + sendPhone;
        } else if (sendPhone.toString().substring(0, 2) == '20') {
            sendPhone = '+' + sendPhone;
        }
        $(this).attr('href', `https://web.whatsapp.com/send?phone=${sendPhone}&text=${msgText}`);
        window.open(this.href, 'mywin', 'left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
        return false;
    });
};

function initNewLeadModal(selectedCountryId = null) {
    // Always destroy and re-initialize Select2 for country select
    if ($('#leadcountry').hasClass('select2-hidden-accessible')) {
        $('#leadcountry').select2('destroy');
    }
    $('#leadcountry').select2({
        theme: 'bootstrap-5',
        placeholder: "Select an option",
        allowClear: true,
        width: '100%'
    });
    // Set value and trigger change if provided
    if (selectedCountryId) {
        $('#leadcountry').val(selectedCountryId).trigger('change');
    } else if ($('#leadcountry').val()) {
        // If already has a value (e.g. from old input), trigger change to update Select2 display
        $('#leadcountry').trigger('change');
    }
    $('#leadcountry').off('change').on('change', function() {
        var value = $(this).val();
        var dependent = $(this).data('dependent');
        console.log('Country changed:', value);
        if (value) {
            axios.post(`/api/countries/get-governments`, {
                value: value,
                dependent: dependent,
            })
            .then(function (response) {
                $(`#${dependent}`).html(response.data);
            });
        }
    });

    // Add Product
    $("#addProduct").off('click').on('click', function (e) {
        e.preventDefault();
        var lastItem = $('#parent div.pro').last();
        var productID = lastItem.find('select[name="product_id[]"]').val();
        var lastname_id = lastItem.attr('id'),
            split_id    = lastname_id.split('_'),
            index       = Number(split_id[1]) + 1,
            newel       = $('.pro:last').clone(true);
        $(newel).attr("index", index);
        $(newel).attr("id","item_"+index);
        $(newel).find('button').attr("id","remove_"+index);
        $(newel).find('.product-select').attr("id","lead-product-"+index);
        $(newel).find('select[name="product_id[]"] option[value="'+productID+'"]').remove();
        $(newel).find('.leadamount').attr("id","leadamount-"+index);
        $(newel).find('.leadprice').attr("id","leadprice-"+index);

        $(newel).find('select[name="product_id[]"]').val('');
        $(newel).find('input[name="quantity[]"]').val('');
        $(newel).find('input[name="price[]"]').val('');
        $(newel).insertAfter(".pro:last");
    });

    // Remove Product
    $(".pro button").off('click').on('click', function (e) {
        e.preventDefault();
        if($(this).attr('id') !== 'remove_1') {
            $(this).closest('.pro').remove();
        }
    });

    // Government -> Area
    $('#leadgovernment').off('change').on('change', function() {
        if($(this).val() != '') {
            var value = $(this).val();
            var dependent = $(this).data('dependent');
            axios.post(`/api/governments/get-areas`,{
                value: value,
                dependent:dependent,
            })
            .then(function (response) {
                $('#'+dependent).html(response.data);
            });
        }
    });

    // Area -> Region
    $('#leadarea').off('change').on('change', function() {
        if($('#leadarea').val() != '') {
            axios.post(`/api/regions/getRegions`,{
                value: $('#leadarea').val(),
            })
            .then(function (response) {
                $('#leadregion').html(response.data);
            });
        }
    });


    // Reset modal on close
    $('#addLeadModal').off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
        $(this).find("input,textarea,select").val('').end()
            .find("input[type=checkbox], input[type=radio]").prop("checked", "").end();
    });
}

export { initLeadModal, initNewLeadModal };
export default initLeadModal;
